/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Calendar legend and scheduling panel for ViewAppointments.
 * @module pages/viewAppointments/ViewAppointmentsCalendarPanel
 */

import CustomCalendar from "../../components/CustomCalendar/index.jsx";
import styles from "../../styles/ViewAppointments.module.css";

const CALENDAR_LEGEND_ITEMS = [
  {
    circleClass: styles.legendCircleApproved,
    labelKey: "components.appointmentScheduleModal.approvedAppointment",
  },
  {
    circleClass: styles.legendCircleScheduled,
    labelKey: "components.appointmentScheduleModal.scheduledAppointment",
  },
  {
    circleClass: styles.legendCircleConfirmed,
    labelKey: "components.appointmentScheduleModal.confirmedAppointment",
  },
  {
    circleClass: styles.legendCircleVirtualScheduled,
    labelKey: "components.appointmentScheduleModal.virtualScheduledAppointment",
  },
  {
    circleClass: styles.legendCircleVirtualConfirmed,
    labelKey: "components.appointmentScheduleModal.virtualConfirmedAppointment",
  },
  {
    circleClass: styles.legendCircleLunchBreak,
    labelKey: "components.appointmentScheduleModal.lunchBreak",
  },
];

const ViewAppointmentsCalendarPanel = ({
  t,
  getCalendarAppointments,
  allAppointmentsForConflict,
  onDateSelect,
  onAppointmentReschedule,
  eventData,
  participatingCompanyData,
  onConfirm,
  isConfirmButtonDisabled,
  senderAppointments,
  highlightedRequirementId,
}) => (
  <div className={styles.rightPanel}>
    <div className={styles.calendarSpacer} />
    <div className={styles.legendContainer}>
      {CALENDAR_LEGEND_ITEMS.map(({ circleClass, labelKey }) => (
        <div key={labelKey} className={styles.legendItem}>
          <div className={`${styles.legendCircle} ${circleClass}`} />
          <span className={styles.legendText}>{t(labelKey)}</span>
        </div>
      ))}
    </div>
    <div className={styles.calendarSection}>
      <div className={`${styles.calendarContainer} calendar-container`}>
        <CustomCalendar
          appointments={getCalendarAppointments()}
          allAppointments={allAppointmentsForConflict || []}
          onDateSelect={onDateSelect}
          onAppointmentReschedule={onAppointmentReschedule}
          eventData={eventData}
          participatingCompanyData={participatingCompanyData}
          showConfirmButton={true}
          onConfirm={onConfirm}
          isConfirmButtonDisabled={isConfirmButtonDisabled}
          senderAppointments={senderAppointments}
          highlightedRequirementId={highlightedRequirementId}
        />
      </div>
    </div>
  </div>
);

export default ViewAppointmentsCalendarPanel;
